import colors from 'config/colors.module.scss';
import { DonationOutput } from 'gql/types';
import { getTranslation } from 'utils/getTranslation';

const t = getTranslation('donor.PackedCellVolumeChart');

export const getConfig = (donationData: DonationOutput[]) => {
  return {
    data: donationData,
    xField: 'donationDate',
    yField: 'packedCellVolume',
    color: colors.pastelRed,
    xAxis: {
      title: {
        text: t('date'),
      },
    },
    yAxis: {
      title: {
        text: t('packedCellVolume'),
      },
      alias: t('packedCellVolume'),
    },
  };
};
